import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";
import FileUpload from "./file-upload/file-upload.component.jsx";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

function Predefined() {
	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	  const [categories, setCategories] = useState([]);
	  const [subcategories, setSubcategories] = useState([]);
	  const [selectedCategory, setSelectedCategory] = useState("");
	   const [selectedSubCategory, setSubSelectedCategory] = useState("");
	  const [subcat, setSubCat] = useState("");
	  const [columns, setColumns] = useState([]);
	  const [tabledata, settableData] = useState([]);	
	  const [fromDate, setFromDate] = useState(null);
       const [toDate, setToDate] = useState(null);
	  
	  useEffect(() => {
		axios.post(`${API_BASE_URL}/api/custom/selectall`,
		{ t: strEncode('pmis_predefined_reports'), cols: strEncode("DISTINCT(c_type) as type") })
		  .then((response) => setCategories(response.data))
		  .catch((error) => console.error("Error fetching categories:", error));

		   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_predefined_reports'), cols: strEncode("*"),whrc : strEncode("n_act_flg = 0 ") }) 
			.then((response) => setSubcategories(response.data))
		  .catch((error) => console.error("Error fetching subcategories:", error));
	  }, []);
	
   
	  const handleSubmit = async (e) => {
		e.preventDefault();
          //console.log("cate",selectedSubCategory)
			if (subcat) {
					let sqlquery = subcat
					const conditions = [];
				if (fromDate) {
					conditions.push(`date >= '${fromDate.toISOString().split("T")[0]}'`);
				}
				if (toDate) {
					conditions.push(`date <= '${toDate.toISOString().split("T")[0]}'`);
				}
					
					if (conditions.length > 0) {
							// Check if query already has WHERE
							if (/where/i.test(subcat)) {
							sqlquery += " AND " + conditions.join(" AND ");
							} else {
							sqlquery += " WHERE " + conditions.join(" AND ");
							}
						}else
						{
							sqlquery = subcat;
						}
					console.log("subcat",sqlquery)
					axios.post(`${API_BASE_URL}/api/predefined`, {
						sql: strEncode(sqlquery)				
					})
					.then((res) => {
                        const rows = res.data?.data || []; // safely get array

    if (rows.length > 0) {
      const columnKeys = Object.keys(rows[0]);

      const formattedColumns = columnKeys.map((key) => ({
        name: key.charAt(0).toUpperCase() + key.slice(1),
        selector: (row) => row[key],
        sortable: true,
        cell: (row) => row[key], // show normal column data
      }));

      setColumns(formattedColumns);
      settableData(rows);
    } else {
      setColumns([]);
      settableData([]);
    }
  })
  .catch((error) => console.error("Error fetching subcategories:", error));

				
				}

			};	
		
	  const handleCategoryChange = (event) => {
		const categoryId = event.target.value;
		setSelectedCategory(categoryId)	 
		if (categoryId === "") {
			setSubcategories([]); // Reset subcategories
			return;
		}
		   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_predefined_reports'), cols: strEncode("*") ,  whrc:strEncode("c_type = '"+categoryId+"'")}) 
			.then((response) => setSubcategories(response.data))
		  .catch((error) => console.error("Error fetching subcategories:", error));
		  settableData([]); // Clear DataTable
	  };

	  const exportData = (type) => {
		const ws = XLSX.utils.json_to_sheet(tabledata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };

	  const handleSubCategoryChange = (event) => {
		     const subcategoryId = event.target.value;
			 setSubSelectedCategory(subcategoryId);
			 axios.post(`${API_BASE_URL}/api/custom/selectall`, {
				t: strEncode('pmis_predefined_reports'),
				cols: strEncode("*"),
				whrc: strEncode(`id = '${subcategoryId}'`)
			})
			.then((response) => {
				setSubCat(response.data[0].c_sql);
			     
			})
			.then((res) => {	
			})
			.catch((error) => console.error("Error fetching subcategories:", error));
	  };
 
	   
	  
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">Liste des rapports</li>
			</ol>
			<h1 className="page-header">Liste des rapports</h1>
			<Panel>
				<PanelHeader>Rapports Prédéfinis : Sélectionnez les filtres de rapport et de date pour générer le résultat
</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				<form id="smart-form-register" className="smart-form" noValidate onSubmit={handleSubmit} >
					<div className="row col-md-12">
						

				{/* <div className="col-3">
				    	<label>Sélectionnez le type de rapport :</label>
						<select className="form-control mb-5px" onChange={handleCategoryChange} value={selectedCategory}>
							<option value="">Sélectionnez le type de rapport</option>
							{categories.map((cat) => (
							<option key={cat.type} value={cat.type}>{cat.type}</option>
							))}
						</select>
                 </div> */}

				 <div className="col-md-3">
						<label>Sélectionnez le type de rapport : </label>
						<select className="form-control mb-5px" onChange={handleSubCategoryChange}>
							<option value="" disabled selected>--Sélectionnez le rapport--</option>
							{subcategories.map((sub) => (
							<option key={sub.id} value={sub.id}>{sub.c_name}</option>
							))}
						</select>
						</div>
<div className="col-2">
													<label> Date de début</label>
													<DatePicker
														selected={fromDate}
														onChange={(date) => setFromDate(date)}
														dateFormat="yyyy-MM-dd"
														placeholderText="Date de début"
														name="from_date"
														className="form-control mb-5px"
														autoComplete="off"
													/>
													
													</div>
													<div className="col-2">
													<label>Date de fin </label>
													<DatePicker
														selected={toDate}
														onChange={(date) => setToDate(date)}
														dateFormat="yyyy-MM-dd"
														placeholderText="Date de fin"
														name="to_date"
														className="form-control mb-5px"
														autoComplete="off"
													/>
													</div>
					
                        <div className="col-2">
                            <button type="submit" className="btn btn-sm btn-primary" style={{ margin:"20px" }}>
								Soumettre
							</button>
						</div>
                         </div>
						 </form>

						<div> 
							<hr/>
								<button onClick={() => exportData("xlsx")} className="btn btn-success">
								Télécharger
								</button>
							<DataTable
									title="Données du rapport"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
						</div>
						
			
				</div>
					
				</PanelBody>
			</Panel>
			
		</div>
	)
}

export default Predefined;